import React from 'react';
import { connect } from 'react-redux';
import { getIsHotelOnly } from 'src/store/view/selectors';
import styled from 'styled-components';
import { getPath } from '../../store/selectors/router';
import { getHeaderTitle } from '../../utils/viewUtils';

const Container = styled.div`
  margin: 4px 0 8px 0;
  padding: 0 8px;
`;

const Text = styled.p`
  font-size: 24px;
  line-height: normal;
  font-weight: bold;
`;

const MobileHeaderTitle = ({ path, isHotelOnly }: PropsFromRedux) => {
  const title = getHeaderTitle(path, isHotelOnly);
  return title ? (
    <Container>
      <Text>{title}</Text>
    </Container>
  ) : null;
};

const mapStateToProps = (state) => ({
  path: getPath(state),
  isHotelOnly: getIsHotelOnly(state),
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ReturnType<typeof mapStateToProps>;

export default connector(MobileHeaderTitle);
